const generateRandomString = (length = 10) =>
  Math.random()
    .toString(20)
    .substr(2, length);



let allMaster = [
  "SCN_BRANCH",
  "SCN_DEPARTMENT",
  "SCN_DESIGNATION",
  "SCN_SUB_DEPARTMENT",
  "SCN_REGION",
  "SCN_PROCESS",
  "SCN_SERVICE_CATEGORY",
  "SCN_SERVICE",
  "SCN_UOM",
  "SCN_KPI_TYPE",
  "SCN_CHANNEL",
  "SCN_SUB_CHANNEL",
  "SCN_DIVISION",
  "SCN_SUB_DIVISION",
  "SCN_CATEGORY",
  "SCN_PERFORMANCE_RATING",
  "SCN_PAYROLL",
  "SCN_EMPLOYEE",
  "SCN_TARGET_TYPE",
  "SCN_STORE",
];
let CommoNMaster = [
  "SCN_BRANCH",
  "SCN_DEPARTMENT",
  "SCN_DESIGNATION",
  "SCN_SUB_DEPARTMENT",
  "SCN_REGION",
  "SCN_PROCESS",
  "SCN_EMPLOYEE",
];
let CHCKMaster = [];
let TKTMaster = ["SCN_SERVICE_CATEGORY", "SCN_SERVICE"];
let WLKMaster = ["SCN_WALKIN_OCCASION", "SCN_WALKIN_CAMPAIGN"];
let VSTMaster = ["SCN_VISIT_CUSTOMER", "SCN_VISIT_POM", "SCN_VISIT_TYPE"];
let PMSMaster = [
  "SCN_UOM",
  "SCN_KPI_TYPE",
  "SCN_CHANNEL",
  "SCN_SUB_CHANNEL",
  "SCN_DIVISION",
  "SCN_SUB_DIVISION",
  "SCN_CATEGORY",
  "SCN_PERFORMANCE_RATING",
  "SCN_TARGET_TYPE",
  "SCN_STORE",
  "SCN_PAYROLL",
];
let BPMaster = ["SCN_OBJECTIVE", "SCN_STRATEGY_GROUP"];
let FMSMaster = [
  "SCN_FMS_AMC_CANCEL_CAT",
  "SCN_FMS_AMC_TYPE",
  "SCN_FMS_AREA",
  "SCN_FMS_BUILDING_TYPE",
  "SCN_FMS_CAR_OPERATOR_MAKE",
  "SCN_FMS_CITY",
  "SCN_FMS_CLIENT_TYPE",
  "SCN_FMS_CLIENT_SUBTYPE",
  "SCN_FMS_CONTROLLER",
  "SCN_FMS_CUSTOMER_GROUP",
  "SCN_FMS_CALL_FUNCTION_TYPE",
  "SCN_FMS_DOORDRIVE_TYPE",
  "SCN_FMS_DRIVE_TYPE",
  "SCN_FMS_ESCLATION_TIME",
  "SCN_FMS_ESCLATION_PER",
  "SCN_FMS_ENCODER_MODEL",
  "SCN_FMS_ENCODER_MAKE",
  "SCN_FMS_EXPERTISE_LEVEL",
  "SCN_FMS_INVERTER_MAKE",
  "SCN_FMS_INSTRUMENT_TYPE",
  "SCN_FMS_LANDING_DISPLAY",
  "SCN_FMS_LIFT_CATEGORY",
  "SCN_FMS_LIFT_TYPE",
  "SCN_FMS_LIFT_MAKE",
  "SCN_FMS_LOCATION",
  "SCN_FMS_MACHINE_ROOM",
  "SCN_FMS_MENU_ACCESS",
  "SCN_FMS_MATERIAL",
  "SCN_FMS_MAINDRIVE_MAKE",
  "SCN_FMS_MACHGEAR_MAKE",
  "SCN_FMS_MOTOR_MAKE",
  "SCN_FMS_PAYMENT_TYPE",
  "SCN_FMS_PAYMENT_TERM",
  "SCN_FMS_RECEIPT_MODE",
  "SCN_FMS_REFNO_TYPE",
  "SCN_FMS_RENEWAL_TYPE",
  "SCN_FMS_ROUTE",
  "SCN_FMS_SCH_VISIT",
  "SCN_FMS_SERVICE",
  "SCN_FMS_SPARE_PARTS",
  "SCN_FMS_SPARE_GROUP",
  "SCN_FMS_STATE",
  "SCN_FMS_TAX",
  "SCN_FMS_TAX_CAT",
  "SCN_FMS_TEAM",
  "SCN_FMS_TKT_CAT",
  "SCN_FMS_TKT_SUBCAT",
  "SCN_FMS_PAUSE_CAT",
  "SCN_FMS_VISTI_SCHEDULE",
  "SCN_FMS_CUSTOMER_DESIGNATION",
  "SCN_FMS_CANCELLATION_REASON",
  "SCN_FMS_RECEIPT_NARRATIONS",
  "SCN_FMS_CUSTOMER_GRADE",
  "SCN_FMS_HIGHWAY_LANDING_TYPE",
  "SCN_FMS_DEDUCTION",
  "SCN_FMS_REASON_FOR_REQUIREMENT",
  "SCN_FMS_PRICE_MASTER",
  "SCN_FMS_MR_LANDING",
  "SCN_FMS_MR_QUOTATION",
  "SCN_FMS_MR_CONTRACT"
];
let All_Strategy = [
  "SCN_PLANNING",
  "SCN_STRATEGY",
  "SCN_BUSINESS_REPORT",
  "SCN_BUDGET",
  "SCN_ACTUAL",
];
let All_Team = [
  "SCN_ORG_CHART",
  "SCN_PMS_KPI_ADDITION",
  "SCN_PMS_SET_TARGET",
  "SCN_PMS_EMPLOYEE_KPI",
  "SCN_PMS_SET_TARGET",
  "SCN_PMS_SET_WEIGHTAGE",
  "SCN_CUSTOMER_TARGET",
  "SCN_CUSTOMER_TARGET_REPORT",
];
let KpiSetup = [
  "SCN_PMS_EMPLOYEE_KPI",
  "SCN_PMS_SET_TARGET",
  "SCN_PMS_SET_WEIGHTAGE",
  "SCN_CUSTOMER_TARGET",
  "SCN_CUSTOMER_TARGET_REPORT",
];

let All_Act = [
  "SCN_CHCK_MY_CHECKLIST",
  "SCN_CHCK_CASE_BASED",
  "SCN_TKT_TICKETS",
  "SCN_TKT_REPORTS",
  "SCN_CHCK_REPORTS",
  "SCN_WALKINS",
  "SCN_WLK_RPRT",
  "SCN_WLKN_FEEDBACK_RPRT",
  "SCN_VISITS",
  "SCN_VISIT_REPORTS",
  "SCN_SURVEY",
  "SCN_SURVEY_REPORTS",
];
let All_Review = [
  "SCN_ANALYTICS",
  "SCN_JEWELLERY_DASHBOARD",
  "SCN_SALES_DASHBOARD",
];
let All_Reward = [
  "SCN_APPRAISAL_SET_APPRAISAL_CYCLE",
  "SCN_APPRAISAL_VIEW_APPRAISAL",
  "SCN_APPRISALTRENDREPORT",
  "SCN_INCENTIVE_POLICY",
  "SCN_INCENTIVE_SET_FREQUENCY",
];
let menu_list = [
  {
    id: generateRandomString(),
    has_children: false,
    onlytextviews: false,
    icon: "mdi-home",
    name: "Home",
    to: "/show_list",
    product_code: ["TECTALIK_CHCK", "TECTALIK_TKT", "TECTALIK_PMS"],
    underline: false,
    isnonadmintoshow: true,
    screen_codeflag: ["SCN_HOME"],
    module_codeflag: ["COMMON"],
  },
  {
    id: generateRandomString(),
    name: window.location.hostname.includes("myboardpage") ? "Planning" : "Strategy" ,
    child: true,
    has_children: true,
    screen_codeflag: All_Strategy,
    product_code: ["TECTALIK_PLANNING"],
    module_codeflag: ["PLANNING"],
    icon: window.location.hostname.includes("myboardpage") ? "mdi-alpha-p-circle" : "mdi-alpha-s-circle" ,
    children: [
      {
        id: generateRandomString(),
        name: "Health Check",
        child: true,
        // screen_code: ["CREATE_MASTERS"],
        product_code: ["TECTALIK_PMS"],
        sub_children: true,
        screen_codeflag: ["SCN_BUSINESS_HEALTH_CHECK"],
        module_codeflag: ["FINANCIAL"],
        icon: "mdi-alpha-b-circle",
        children: [
          {
            id: generateRandomString(),
            icon: "mdi-heart-pulse",
            name: "View Health Check",
            to: "/health_check_invite_new",
            has_children: false,
            product_code: ["TECTALIK_PMS"],
            screen_codeflag: ["SCN_BUSINESS_HEALTH_CHECK"],
            module_codeflag: ["FINANCIAL"],
          },
          {
            id: generateRandomString(),
            icon: "mdi-shield-check",
            name: "Take Operational Health Check ",
            to: "/admin_homescreen_operational",
            has_children: false,
            product_code: ["TECTALIK_PMS"],
            screen_codeflag: ["SCN_TAKE_HEALTH_CHECK"],
            module_codeflag: ["FINANCIAL"],
          },
          {
            id: generateRandomString(),
            icon: "mdi-clipboard-pulse-outline",
            name: "Take Financial Health Check ",
            to: "/admin_health_check_homescreen",
            has_children: false,
            product_code: ["TECTALIK_PMS"],
            screen_codeflag: ["SCN_TAKE_HEALTH_CHECK"],
            module_codeflag: ["FINANCIAL"],
          }
        ]
      },
      {
        id: generateRandomString(),
        name: "Business Plan",
        child: true,
        sub_children: true,
        icon: "mdi-alpha-b-circle",
        screen_codeflag: [
          "SCN_PLANNING",
          "SCN_STRATEGY",
          "SCN_BUSINESS_REPORT",
        ],
        product_code: ["TECTALIK_PLANNING"],
        module_codeflag: ["PLANNING"],
        children: [
          {
            id: generateRandomString(),
            name: "Goals",
            child: true,
            icon: "mdi-alpha-g-circle",
            to: "/business_plan",
            // screen_code: ["CREATE_CHK"],
            product_code: ["TECTALIK_PLANNING"],
            screen_codeflag: ["SCN_PLANNING"],
            module_codeflag: ["PLANNING"],
          },
          {
            id: generateRandomString(),
            name: "Strategy",
            child: true,
            icon: "mdi-alpha-s-circle",
            to: "/set_strategy",
            // screen_code: ["CREATE_CHK", "SCN_BUDGET", "SCN_ACTUAL"],
            product_code: ["TECTALIK_PLANNING"],
            screen_codeflag: ["SCN_STRATEGY"],
            module_codeflag: ["PLANNING", "FINANCIAL", "FINANCIAL"],
          },
          {
            id: generateRandomString(),
            name: "Financials",
            child: true,
            icon: "mdi-alpha-f-circle",
            to: "/financials_landing",
            // screen_code: ["CREATE_CHK", "SCN_BUDGET", "SCN_ACTUAL"],
            product_code: ["TECTALIK_PLANNING"],
            screen_codeflag: ["SCN_STRATEGY"],
            module_codeflag: ["PLANNING", "FINANCIAL", "FINANCIAL"],
          },
          {
            id: generateRandomString(),
            name: "What If",
            child: true,
            icon: "mdi-alpha-w-circle",
            to: "/what_if_landing",
            // screen_code: ["CREATE_CHK", "SCN_BUDGET", "SCN_ACTUAL"],
            product_code: ["TECTALIK_PLANNING"],
            screen_codeflag: ["SCN_STRATEGY"],
            module_codeflag: ["PLANNING", "FINANCIAL", "FINANCIAL"],
          },

          {
            id: generateRandomString(),
            name: "Combination Of Masters",
            child: true,
            icon: "mdi-alpha-c-circle",
            to: "/combination_of_masters",
            // screen_code: ["CREATE_CHK", "SCN_BUDGET", "SCN_ACTUAL"],
            product_code: ["TECTALIK_PLANNING"],
            screen_codeflag: ["SCN_STRATEGY"],
            module_codeflag: ["PLANNING", "FINANCIAL", "FINANCIAL"],
          },

          {
            id: generateRandomString(),
            name: "What If",
            child: true,
            icon: "mdi-alpha-w-circle",
            to: "/what_if_landing_dynamic",
            // screen_code: ["CREATE_CHK", "SCN_BUDGET", "SCN_ACTUAL"],
            product_code: ["TECTALIK_PLANNING"],
            screen_codeflag: ["SCN_STRATEGY"],
            module_codeflag: ["PLANNING", "FINANCIAL", "FINANCIAL"],
          },

          // {
          //     id: generateRandomString(),
          //     name: "Business Report",
          //     child: true,
          //     icon: "mdi-alpha-b-circle",
          //     to: "/business_report",
          //     screen_code: ["CREATE_CHK"],
          //     product_code: ["TECTALIK_PLANNING"],
          //     screen_codeflag: ["SCN_BUSINESS_REPORT"],
          //     module_codeflag: ["PLANNING"],
          // },
        ],
      },
      {
        id: generateRandomString(),
        name: "Financial Plan",
        child: true,
        // screen_code: ["CREATE_MASTERS"],
        product_code: ["TECTALIK_PMS"],
        sub_children: true,
        screen_codeflag: ["SCN_BUDGET", "SCN_ACTUAL"],
        module_codeflag: ["FINANCIAL", "FINANCIAL"],
        icon: "mdi-alpha-f-circle",
        children: [
          {
            id: generateRandomString(),
            name: "Budget",
            child: true,
            icon: "mdi-alpha-b-circle",
            to: "/budget",
            screen_code: ["CREATE_MASTERS"],
            product_code: ["TECTALIK_PMS"],
            screen_codeflag: ["SCN_BUDGET"],
            module_codeflag: ["FINANCIAL"],
          },
          {
            id: generateRandomString(),
            name: "Actual",
            child: true,
            icon: "mdi-alpha-a-circle",
            to: "/actual",
            screen_code: ["CREATE_MASTERS"],
            product_code: ["TECTALIK_PMS"],
            screen_codeflag: ["SCN_ACTUAL"],
            module_codeflag: ["FINANCIAL"],
          },
          {
            id: generateRandomString(),
            name: "Budget Reports",
            child: true,
            icon: "mdi-alpha-r-circle",
            to: "/budget_reports",
            screen_code: ["CREATE_MASTERS"],
            product_code: ["TECTALIK_PMS"],
            screen_codeflag: ["SCN_BUDGET"],
            module_codeflag: ["FINANCIAL"],
          },
          // actual report
          {
            id: generateRandomString(),
            name: "Actual Reports",
            child: true,
            icon: "mdi-alpha-a-circle",
            to: "/actual_reports",
            screen_code: ["CREATE_MASTERS"],
            product_code: ["TECTALIK_PMS"],
            screen_codeflag: ["SCN_ACTUAL"],
            module_codeflag: ["FINANCIAL"],
          },
        ],
      },
      {
        id: generateRandomString(),
        name: "Bullseye",
        child: true,
        // screen_code: ["CREATE_MASTERS"],
        product_code: ["TECTALIK_PMS"],
        sub_children: true,
        screen_codeflag: ["SCN_BUDGET", "SCN_ACTUAL"],
        module_codeflag: ["FINANCIAL", "FINANCIAL"],
        icon: "mdi-alpha-f-circle",
        children: [
          {
            id: generateRandomString(),
            icon: "mdi-file-tree-outline",
            name: "KPI Impact Setup",
            to: "/kpi_impact_landing",
            // screen_code: ["CREATE_MASTERS"],
            has_children: false,
            product_code: ["TECTALIK_PMS"],
            screen_codeflag: ["SCN_KPI_IMPACT_SETUP"],
            module_codeflag: ["PERFORMANCE"],
          },
          {
            id: generateRandomString(),
            icon: "mdi-sitemap",
            name: "KPI Impact Chart",
            to: "/kpi_impact_tree",
            // screen_code: ["CREATE_MASTERS"],
            has_children: false,
            product_code: ["TECTALIK_PMS"],
            screen_codeflag: ["SCN_KPI_IMPACT_TREE"],
            module_codeflag: ["PERFORMANCE"],
          },
          {
            id: generateRandomString(),
            icon: "mdi-chart-gantt",
            name: "KPI Bullseye",
            to: "/kpi_impact_tree_new",
            // screen_code: ["CREATE_MASTERS"],
            has_children: false,
            product_code: ["TECTALIK_PMS"],
            screen_codeflag: ["SCN_KPI_IMPACT_TREE_NEW"],
            module_codeflag: ["PERFORMANCE"],
          },
          {
            id: generateRandomString(),
            icon: "mdi-chart-donut-variant",
            name: "KPI Bullseye New",
            to: "/kpi_bullseye_new",
            has_children: false,
            product_code: ["TECTALIK_PMS"],
            screen_codeflag: ["SCN_KPI_BULLSEYE_NEW"],
            module_codeflag: ["PERFORMANCE"],
          },
        ]
      },
      // {
      //   id: generateRandomString(),
      //   name: "Business Health Check",
      //   child: true,
      //   // screen_code: ["CREATE_MASTERS"],
      //   product_code: ["TECTALIK_PMS"],
      //   sub_children: true,
      //   screen_codeflag: ["SCN_BUSINESS_HEALTH_CHECK"],
      //   module_codeflag: ["FINANCIAL"],
      //   icon: "mdi-alpha-b-circle",
      //   children: [
      //     {
      //       id: generateRandomString(),
      //       icon: "mdi-heart-pulse",
      //       name: "Health Check",
      //       to: "/health_check_invite_details",
      //       has_children: false,
      //       product_code: ["TECTALIK_PMS"],
      //       screen_codeflag: ["SCN_BUSINESS_HEALTH_CHECK"],
      //       module_codeflag: ["FINANCIAL"],
      //     },
      //     // {
      //     //   id: generateRandomString(),
      //     //   icon: "mdi-clipboard-pulse-outline",
      //     //   name: "Health Check Report",
      //     //   to: "/health_check_report",
      //     //   has_children: false,
      //     //   product_code: ["TECTALIK_PMS"],
      //     //   screen_codeflag: ["SCN_BUSINESS_HEALTH_CHECK"],
      //     //   module_codeflag: ["FINANCIAL"],
      //     // }
      //   ]
      // }
    ],
  },
  {
    id: generateRandomString(),
    icon: window.location.hostname.includes("myboardpage") ?  "mdi-alpha-a-circle" : "mdi-alpha-t-circle",
    name: window.location.hostname.includes("myboardpage") ?  "Accountability" : "Team" ,
    // teamdrop:"yes",
    // to: "/team_list",
    has_children: true,
    screen_codeflag: All_Team,
    product_code: ["TECTALIK_CHCK", "TECTALIK_TKT", "TECTALIK_PMS"],
    module_codeflag: ["COMMON"],
    children: [
      // {
      //   id: generateRandomString(),
      //   icon: "mdi-family-tree",
      //   name: "Organization Chart",
      //   to: "/org_chart",
      //   // screen_code: ["CREATE_MASTERS"],
      //   has_children: false,
      //   product_code: ["TECTALIK_CHCK", "TECTALIK_TKT", "TECTALIK_PMS"],
      //   // isnonadmintoshow: true,
      //   screen_codeflag: ["SCN_ORG_CHART"],
      //   module_codeflag: ["COMMON"],
      // },
      // {
      //   id: generateRandomString(),
      //   icon: "mdi-family-tree",
      //   // name: "Organization Chart New",
      //   name: "Organization Chart",
      //   to: "/org_chart_new",
      //   // screen_code: ["CREATE_MASTERS"],
      //   has_children: false,
      //   product_code: ["TECTALIK_CHCK", "TECTALIK_TKT", "TECTALIK_PMS"],
      //   // isnonadmintoshow: true,
      //   screen_codeflag: ["SCN_ORG_CHART"],
      //   module_codeflag: ["COMMON"],
      // },
      // {
      //   id: generateRandomString(),
      //   icon: "mdi-family-tree",
      //   name: "Organization Chart Second",
      //   to: "/organization_chart",
      //   has_children: false,
      //   product_code: ["TECTALIK_CHCK", "TECTALIK_TKT", "TECTALIK_PMS"],
      //   screen_codeflag: ["SCN_ORG_CHART"],
      //   module_codeflag: ["COMMON"],
      // },
      {
        id: generateRandomString(),
        icon: "mdi-family-tree",
        name: "Organization Chart",
        // to: "/orgchart_sample",
        to: "/org_ui_new",
        has_children: false,
        product_code: ["TECTALIK_CHCK", "TECTALIK_TKT", "TECTALIK_PMS"],
        screen_codeflag: ["SCN_ORG_CHART"],
        module_codeflag: ["COMMON"],
      },
      // {
      //   id: generateRandomString(),
      //   icon: "mdi-family-tree",
      //   name: "Flow Chart",
      //   to: "/flow_chart",
      //   has_children: false,
      //   product_code: ["TECTALIK_CHCK", "TECTALIK_TKT", "TECTALIK_PMS"],
      //   screen_codeflag: ["SCN_ORG_CHART"],
      //   module_codeflag: ["COMMON"],
      // },
      {
        id: generateRandomString(),
        icon: "mdi-alpha-k-box",
        to: "/kpi_additions",
        name: "Kpi Addition",
        // screen_code: ["CREATE_MASTERS"],
        has_children: false,
        product_code: ["TECTALIK_PMS"],
        screen_codeflag: ["SCN_PMS_KPI_ADDITION"],
        module_codeflag: ["PERFORMANCE"],
      },
      {
        id: generateRandomString(),
        icon: "mdi-trophy-award",
        name: "KPI Updation",
        to: "/actual_ViewLanding",
        // screen_code: ["CREATE_MASTERS"],
        has_children: false,
        product_code: ["TECTALIK_PMS"],
        screen_codeflag: ["SCN_PMS_SET_TARGET"],
        module_codeflag: ["PERFORMANCE"],
      },

      // {
      //   id: generateRandomString(),
      //   icon: "mdi-cog",
      //   name: "KPI settings",
      //   to: "/kpi_settings_landing",
      //   // screen_code: ["CREATE_MASTERS"],
      //   has_children: false,
      //   product_code: ["TECTALIK_PMS"],
      //   screen_codeflag: ["SCN_KPI_SETTING"],
      //   module_codeflag: ["PERFORMANCE"],
      // },
      {
        id: generateRandomString(),
        icon: "mdi-file-document",
        name: "Acknowledgement Report",
        to: "/kpi_role_ack_report",
        // screen_code: ["CREATE_MASTERS"],
        has_children: false,
        product_code: ["TECTALIK_PMS"],
        screen_codeflag: ["SCN_PMS_KPI_ROLES_REPORT"],
        module_codeflag: ["PERFORMANCE"],
      },
      {
        id: generateRandomString(),
        icon: "mdi-file-chart",
        name: "KPI Status Report",
        to: "/kpi_overall_ack_report",
        // screen_code: ["CREATE_MASTERS"],
        has_children: false,
        product_code: ["TECTALIK_PMS"],
        screen_codeflag: ["SCN_OVERALL_ACK_REPORT"],
        module_codeflag: ["PERFORMANCE"],
      },
      {
        id: generateRandomString(),
        icon: "mdi-alpha-k-box",
        name: "Kpi Set Up",
        // screen_code: ["CREATE_MASTERS"],
        sub_children: true,
        product_code: ["TECTALIK_PMS"],
        screen_codeflag: KpiSetup,
        module_codeflag: ["PERFORMANCE"],
        children: [
          {
            id: generateRandomString(),
            icon: "mdi-account-star",
            name: " Assign KPI",
            to: "/employee_kpi",
            // screen_code: ["CREATE_MASTERS"],
            has_children: false,
            product_code: ["TECTALIK_PMS"],
            screen_codeflag: ["SCN_PMS_EMPLOYEE_KPI"],
            module_codeflag: ["PERFORMANCE"],
          },
          {
            id: generateRandomString(),
            icon: "mdi-bullseye-arrow",
            name: "Set Target",
            to: "/set_target_ViewLanding",
            // screen_code: ["CREATE_MASTERS"],
            has_children: false,
            product_code: ["TECTALIK_PMS"],
            screen_codeflag: ["SCN_PMS_SET_TARGET"],
            module_codeflag: ["PERFORMANCE"],
          },
          {
            id: generateRandomString(),
            icon: "mdi-scale-balance",
            name: "Set Weightage",
            to: "/set_weightage",
            // screen_code: ["CREATE_MASTERS"],
            has_children: false,
            product_code: ["TECTALIK_PMS"],
            screen_codeflag: ["SCN_PMS_SET_WEIGHTAGE"],
            module_codeflag: ["PERFORMANCE"],
          },

        ],
      },
      {
        id: generateRandomString(),
        icon: "mdi-alpha-f-box",
        name: "Feedback",
        has_children: true,
        product_code: ["TECTALIK_PMS"],
        screen_codeflag: ["SCN_FEEDBACK"],
        module_codeflag: ["PERFORMANCE"],
        children: [
          {
            id: generateRandomString(),
            icon: "mdi-alpha-f-circle",
            name: "Feedback",
            to: "/feedback_dashboards",
            // screen_code: ["CREATE_MASTERS"],
            has_children: false,
            product_code: ["TECTALIK_PMS"],
            screen_codeflag: ["SCN_FEEDBACK"],
            module_codeflag: ["PERFORMANCE"],
          },
          {
            id: generateRandomString(),
            icon: "mdi-alpha-r-circle",
            name: "Feedback Report",
            to: "/feedback_report",
            // screen_code: ["CREATE_MASTERS"],
            has_children: false,
            product_code: ["TECTALIK_PMS"],
            screen_codeflag: ["SCN_FEEDBACK_REPORT"],
            module_codeflag: ["PERFORMANCE"],
          },
        ],
      },
      {
        id: generateRandomString(),
        icon: "mdi-file-chart",
        name: "Scorecard",
        to: "/scorecard_new",
        // screen_code: ["CREATE_MASTERS"],
        has_children: false,
        product_code: ["TECTALIK_PMS"],
        screen_codeflag: ["SCN_APPRAISAL_VIEW_APPRAISAL"],
        module_codeflag: ["PERFORMANCE"],
      },
    ],
  },
  {
    id: generateRandomString(),
    name: window.location.hostname.includes("myboardpage") ?  "Governance" : "Act",
    icon: window.location.hostname.includes("myboardpage") ?  "mdi-alpha-g-circle" : "mdi-alpha-a-circle" ,
    //    to: "/quick_links",
    // screen_code: ["CREATE_CHK", "RUN_REPORTS"],
    product_code: [
      "TECTALIK_CHCK",
      "TECTALIK_TKT",
      "TECTALIK_SURVEY",
      "TECTALIK_VISITS",
      "TECTALIK_WLK",
    ],
    has_children: true,
    screen_codeflag: All_Act,
    module_codeflag: ["COMPLIANCE", "WALKINS", "VISITS", "SURVEYS", "TICKETS"],
    children: [
      {
        id: generateRandomString(),
        name: "Checklist",
        icon: "mdi-alpha-c-circle",
        child: true,
        sub_children: true,
        // screen_code: ["CREATE_CHK", "RUN_REPORTS"],
        product_code: ["TECTALIK_CHCK"],
        screen_codeflag: [
          "SCN_CHCK_MY_CHECKLIST",
          "SCN_CHCK_CASE_BASED",
          "SCN_CHCK_REPORTS",
        ],
        module_codeflag: ["COMPLIANCE"],
        children: [
          {
            id: generateRandomString(),
            icon: "mdi-clipboard-edit",
            name: "My Checklist",
            to: "/MainChecklist",
            has_children: false,
            // screen_code: ["CREATE_CHK"],
            product_code: ["TECTALIK_CHCK"],
            screen_codeflag: ["SCN_CHCK_MY_CHECKLIST", "SCN_CHCK_CASE_BASED"],
            module_codeflag: ["COMPLIANCE"],
          },
          {
            id: generateRandomString(),
            icon: "mdi-alpha-t-box",
            name: "My Tasks",
            to: "/myTasks",
            // screen_code: ["CREATE_CHK"],
            product_code: ["TECTALIK_CHCK"],
            screen_codeflag: ["SCN_CHCK_MY_CHECKLIST", "SCN_CHCK_CASE_BASED"],
            module_codeflag: ["COMPLIANCE"],
          },
          {
            id: generateRandomString(),
            icon: "mdi-alpha-r-box",
            name: "Reports",
            to: "/showlist_all_report",
            // screen_code: ["RUN_REPORTS"],
            product_code: ["TECTALIK_CHCK"],
            screen_codeflag: ["SCN_CHCK_REPORTS"],
            module_codeflag: ["COMPLIANCE"],
          },
        ],
      },
      {
        id: generateRandomString(),
        name: "Tickets",
        // screen_code: ["CREATE_MASTERS"],
        icon: "mdi-alpha-t-circle",
        product_code: ["TECTALIK_TKT"],
        // screen_code: ["CREATE_CHK", "RUN_REPORTS"],
        child: true,
        sub_children: true,
        screen_codeflag: ["SCN_TKT_TICKETS", "SCN_TKT_REPORTS"],
        module_codeflag: ["TICKETS"],
        children: [
          {
            id: generateRandomString(),
            icon: "mdi-clipboard-edit",
            name: "Tickets",
            to: "/ticket",
            screen_code: ["CREATE_CHK"],
            product_code: ["TECTALIK_TKT"],
            screen_codeflag: ["SCN_TKT_TICKETS"],
            module_codeflag: ["TICKETS"],
          },
          {
            id: generateRandomString(),
            icon: "mdi-alpha-s-box",
            name: "SLA score",
            to: "/SlaScore",
            screen_code: ["CREATE_CHK"],
            product_code: ["TECTALIK_TKT"],
            screen_codeflag: ["SCN_TKT_TICKETS"],
            module_codeflag: ["TICKETS"],
          },
          {
            id: generateRandomString(),
            icon: "mdi-alpha-r-box",
            name: "Reports",
            to: "/tickets_report",
            screen_code: ["RUN_REPORTS"],
            product_code: ["TECTALIK_TKT"],
            screen_codeflag: ["SCN_TKT_REPORTS"],
            module_codeflag: ["TICKETS"],
          },
        ],
      },
      {
        id: generateRandomString(),
        name: "Walkin",
        child: true,
        sub_children: true,
        icon: "mdi-alpha-w-circle",
        screen_code: ["CREATE_CHK"],
        screen_codeflag: [
          "SCN_WALKINS",
          "SCN_WLK_RPRT",
          "SCN_WLKN_FEEDBACK_RPRT",
        ],
        product_code: ["TECTALIK_WLK"],
        module_codeflag: ["WALKINS"],
        children: [
          {
            id: generateRandomString(),
            name: "Age Master",
            child: true,
            icon: "mdi-alpha-a-circle ",
            to: "/walkins_age_master",
            screen_code: ["CREATE_MASTERS"],
            product_code: ["TECTALIK_WLK"],
            screen_codeflag: ["SCN_WALKINS"],
            module_codeflag: ["WALKINS"],
          },
          {
            id: generateRandomString(),
            name: "Walkins",
            child: true,
            icon: "mdi-alpha-w-circle ",
            to: "/walkin/landing",
            screen_code: ["CREATE_MASTERS"],
            product_code: ["TECTALIK_WLK"],
            screen_codeflag: ["SCN_WALKINS"],
            module_codeflag: ["WALKINS"],
          },
          {
            id: generateRandomString(),
            name: "Reports",
            child: true,
            icon: "mdi-alpha-r-circle ",
            to: "/walkins/reports",
            screen_code: ["CREATE_MASTERS"],
            product_code: ["TECTALIK_WLK"],
            screen_codeflag: ["SCN_WLK_RPRT"],
            module_codeflag: ["WALKINS"],
          },

          {
            id: generateRandomString(),
            name: "Feedback Reports",
            child: true,
            icon: "mdi-alpha-r-circle ",
            to: "/feedback/reports",
            screen_code: ["CREATE_MASTERS"],
            product_code: ["TECTALIK_WLK"],
            screen_codeflag: ["SCN_WLKN_FEEDBACK_RPRT"],
            module_codeflag: ["WALKINS"],
          },
        ],
      },
      {
        id: generateRandomString(),
        name: "Visits",
        child: true,
        sub_children: true,
        icon: "mdi-alpha-v-circle",
        screen_code: ["CREATE_CHK"],
        screen_codeflag: ["SCN_VISITS", "SCN_VISIT_REPORTS"],
        product_code: ["TECTALIK_VISITS"],
        module_codeflag: ["VISITS"],
        children: [
          {
            id: generateRandomString(),
            name: "Visits",
            child: true,
            icon: "mdi-alpha-v-circle ",
            to: "/visits/landing",
            screen_code: ["CREATE_MASTERS"],
            product_code: ["TECTALIK_VISITS"],
            screen_codeflag: ["SCN_VISITS"],
            module_codeflag: ["VISITS"],
          },
          {
            id: generateRandomString(),
            name: "Reports",
            child: true,
            icon: "mdi-alpha-r-circle",
            to: "/visitReport",
            screen_code: ["CREATE_MASTERS"],
            product_code: ["TECTALIK_VISITS"],
            screen_codeflag: ["SCN_VISIT_REPORTS"],
            module_codeflag: ["VISITS"],
          },
        ],
      },
      {
        id: generateRandomString(),
        name: "Attendance",
        child: true,
        sub_children: true,
        icon: "mdi-alpha-a-circle",
        screen_code: ["CREATE_CHK"],
        screen_codeflag: ["SCN_ATTENDANCE", "SCN_ATTENDANCE_REPORTS"],
        product_code: ["TECTALIK_VISITS"],
        module_codeflag: ["ATTENDANCE"],
        children: [
          {
            id: generateRandomString(),
            name: "Attendance",
            child: true,
            icon: "mdi-alpha-a-box ",
            to: "/attendance_landing",
            screen_code: ["CREATE_MASTERS"],
            product_code: ["TECTALIK_VISITS"],
            screen_codeflag: ["SCN_ATTENDANCE"],
            module_codeflag: ["ATTENDANCE"],
          },
          {
            id: generateRandomString(),
            name: "Attendance Reports",
            child: true,
            icon: "mdi-alpha-r-box",
            to: "/visits/attendance_report",
            screen_code: ["CREATE_MASTERS"],
            product_code: ["TECTALIK_VISITS"],
            screen_codeflag: ["SCN_ATTENDANCE_REPORTS"],
            module_codeflag: ["ATTENDANCE"],
          }
        ],
      },
      {
        id: generateRandomString(),
        name: "Survey",
        child: true,
        sub_children: true,
        icon: "mdi-alpha-s-circle",
        // screen_code: ["CREATE_CHK"],
        screen_codeflag: ["SCN_SURVEY", "SCN_SURVEY_REPORTS"],
        product_code: ["TECTALIK_SURVEY"],
        module_codeflag: ["SURVEYS"],
        children: [
          {
            id: generateRandomString(),
            name: "Survey",
            child: true,
            icon: "mdi-alpha-s-circle",
            to: "/survey",
            // screen_code: ["CREATE_CHK"],
            product_code: ["TECTALIK_SURVEY"],
            screen_codeflag: ["SCN_SURVEY"],
            module_codeflag: ["SURVEYS"],
          },
          {
            id: generateRandomString(),
            name: "Type of Questionnaire",
            child: true,
            icon: "mdi-alpha-t-circle",
            to: "/type_of_questionaire",
            // screen_code: ["CREATE_CHK"],
            product_code: ["TECTALIK_SURVEY"],
            screen_codeflag: ["SCN_SURVEY"],
            module_codeflag: ["SURVEYS"],
          },
          {
            id: generateRandomString(),
            name: "Reports",
            child: true,
            icon: "mdi-alpha-r-circle",
            to: "/survey_reports",
            // screen_code: ["CREATE_CHK"],
            product_code: ["TECTALIK_SURVEY"],
            screen_codeflag: ["SCN_SURVEY_REPORTS"],
            module_codeflag: ["SURVEYS"],
          },
        ],
      },
      {
        id: generateRandomString(),
        name: "Workflow",
        icon: "mdi-alpha-w-circle",
        child: true,
        sub_children: true,
        // screen_code: ["CREATE_CHK", "RUN_REPORTS"],
        product_code: ["TECTALIK_CHCK"],
        screen_codeflag: [
          "SCN_CHCK_WORK_FLOW"
        ],
        module_codeflag: ["COMPLIANCE"],
        children: [
          {
            id: generateRandomString(),
            icon: "mdi-checkbox-marked-outline",
            name: "Work Flow",
            to: "/case_based_workflow",
            has_children: false,
            // screen_code: ["CREATE_CHK"],
            product_code: ["TECTALIK_CHCK"],
            screen_codeflag: ["SCN_CHCK_WORK_FLOW"],
            module_codeflag: ["COMPLIANCE"],
          },
        ],
      },
      {
        id: generateRandomString(),
        name: "Forms",
        child: true,
        sub_children: true,
        icon: "mdi-alpha-f-circle",
        // screen_code: ["CREATE_CHK"],
        screen_codeflag: ["SCN_BRANCH"],
        product_code: ["TECTALIK_CHCK"],
        module_codeflag: ["MASTERS"],
        children: [
          {
            id: generateRandomString(),
            name: "Forms",
            child: true,
            icon: "mdi-form-select",
            to: "/forms_master",
            screen_code: ["CREATE_MASTERS"],
            product_code: ["TECTALIK_CHCK"],
            screen_codeflag: ["SCN_BRANCH"],
            module_codeflag: ["MASTERS"],
          },
        ],
      },
      {
        id: generateRandomString(),
        name: "Meeting",
        child: true,
        sub_children: true,
        icon: "mdi-alpha-m-circle",
        // screen_code: ["CREATE_CHK"],
        screen_codeflag: ["SCN_BRANCH"],
        product_code: ["TECTALIK_CHCK"],
        module_codeflag: ["MASTERS"],
        children: [
          {
            id: generateRandomString(),
            name: "Meeting",
            child: true,
            icon: "mdi-alpha-m-circle",
            to: "/meetings_new",
            screen_code: ["CREATE_MASTERS"],
            product_code: ["TECTALIK_CHCK"],
            screen_codeflag: ["SCN_BRANCH"],
            module_codeflag: ["MASTERS"],
          },
        ],
      },
    ],
  },

  // {
  //   id: generateRandomString(),
  //   name: "Forms",
  //   child: true,
  //   has_children: true,
  //   icon: "mdi-alpha-f-circle",
  //   screen_codeflag: ["SCN_FORMS"],
  //   product_code: ["TECTALIK_FORMS"],
  //   module_codeflag: ["FORMS"],
  //   children: [
  //     {
  //       id: generateRandomString(),
  //       name: "Forms",
  //       child: true,
  //       icon: "mdi-form-select",
  //       to: "/forms_master",
  //       screen_code: ["CREATE_MASTERS"],
  //       product_code: ["TECTALIK_FORMS"],
  //       screen_codeflag: ["SCN_FORMS"],
  //       module_codeflag: ["FORMS"],
  //     },
  //   ],
  // },
  // {
  //   id: generateRandomString(),
  //   name: "Meeting",
  //   child: true,
  //   has_children: true,
  //   icon: "mdi-alpha-m-circle",
  //   // screen_code: ["CREATE_CHK"],
  //   screen_codeflag: ["SCN_MEETING"],
  //   product_code: ["TECTALIK_MEETING"],
  //   module_codeflag: ["MEETING"],
  //   children: [
  //     {
  //       id: generateRandomString(),
  //       name: "Meeting",
  //       child: true,
  //       icon: "mdi-form-select",
  //       to: "/meetings",
  //       screen_code: ["CREATE_MASTERS"],
  //       product_code: ["TECTALIK_MEETING"],
  //       screen_codeflag: ["SCN_MEETING"],
  //       module_codeflag: ["MEETING"],
  //     },
  //   ],
  // },

  // {
  //     id: generateRandomString(),
  //     icon: "mdi-alpha-m-circle",
  //     name: "Meetings",
  //     to: "/meetings",
  //     screen_code: ["CREATE_MASTERS"],
  //     has_children: false,
  //     product_code: ["TECTALIK_ANALYTICS"],
  //     // isnonadmintoshow: true,
  //     screen_codeflag: ["SCN_ORG_CHART"],
  //     module_codeflag: ["COMMON"],

  // },

  {
    id: generateRandomString(),
    icon: window.location.hostname.includes("myboardpage") ?  "mdi-alpha-e-circle" : "mdi-alpha-r-circle" ,
    name: window.location.hostname.includes("myboardpage") ?  "Evaluation" : "Review",
    // teamdrop:"yes",
    // to: "/team_list",
    has_children: true,
    screen_code: ["CREATE_MASTERS"],

    product_code: ["TECTALIK_ANALYTICS"],
    // isnonadmintoshow: true,
    screen_codeflag: All_Review,
    module_codeflag: ["COMMON"],
    children: [
      {
        id: generateRandomString(),
        icon: "mdi-alpha-a-circle",
        name: "Analytics",
        to: "/kpi_bots",
        // screen_code: ["CREATE_MASTERS"],
        has_children: false,
        product_code: ["TECTALIK_ANALYTICS"],
        // isnonadmintoshow: true,
        screen_codeflag: ["SCN_ANALYTICS"],
        module_codeflag: ["COMMON"],
      },
      //  {
      //   id: generateRandomString(),
      //   icon: "mdi-alpha-a-circle",
      //   name: "configurator",
      //   to: "/configurator",
      //   screen_code: ["CREATE_MASTERS"],
      //   has_children: false,
      //   product_code: ["TECTALIK_ANALYTICS"],
      //   // isnonadmintoshow: true,
      //   screen_codeflag: ["SCN_ORG_CHART"],
      //   module_codeflag: ["COMMON"],
      // },
      // {
      //   id: generateRandomString(),
      //   icon: "mdi-alpha-a-circle",
      //   name: "Jewellery Dashboard",
      //   to: "/jewellery",
      //   screen_code: ["CREATE_MASTERS"],
      //   has_children: false,
      //   product_code: ["TECTALIK_ANALYTICS"],
      //   // isnonadmintoshow: true,
      //   screen_codeflag: ["SCN_ORG_CHART"],
      //   module_codeflag: ["COMMON"],
      // },
      {
        id: generateRandomString(),
        name: "Analytic Solution",
        child: true,
        icon: "mdi-v-circle",
        screen_code: ["CREATE_MASTERS"],
        product_code: ["TECTALIK_ANALYTICS"],
        sub_children: true,
        grouping_children: true,
        screen_codeflag: ["SCN_JEWELLERY_DASHBOARD", "SCN_SALES_DASHBOARD"],
        module_codeflag: ["COMMON"],
        has_grand_children: false,
        children: [
          {
            id: generateRandomString(),
            name: "Inventory Optimization",
            child: true,
            icon: "mdi-alpha-i-circle",
            // to: "/jewellery",
            to: (localStorage.getItem("domain") == "alagar") ? "/jewellery_dashboard_alagar" : "/jewellery_dashboard_vbj",
            // screen_code: ["CREATE_MASTERS"],
            product_code: ["TECTALIK_ANALYTICS"],
            screen_codeflag: ["SCN_JEWELLERY_DASHBOARD"],
            module_codeflag: ["COMMON"],
          },
          {
            id: generateRandomString(),
            icon: "mdi-alpha-s-box",
            name: "Sales Predictor",
            to: "/sales_dashboard",
            // screen_code: ["CREATE_MASTERS"],
            product_code: ["TECTALIK_ANALYTICS"],
            screen_codeflag: ["SCN_SALES_DASHBOARD"],
            module_codeflag: ["COMMON"],
          },
        ],
      },
    ],
  },







];



export default menu_list;
